import React, { FC } from 'react';
import styled from 'styled-components';

const StyledError = styled.div`
    padding: 12px;
    display: flex;
    justify-content: center;
    align-items: center;
    background-color: #d32f2f;
    color: #fff;
    text-align: center;
`;
interface ErrorProps {
    error?: string;
}

const Error: FC<ErrorProps> = ({ error }) => {
    if (!error) {
        return null;
    }
    return <StyledError>{error}</StyledError>;
};

export default Error;
